import { apiJson, apiText } from '../api';
import type { ArticleNote } from '../types';

export async function getArticleNote(articleId: string): Promise<ArticleNote> {
  return apiJson<ArticleNote>(`/api/stories/${encodeURIComponent(articleId)}/note`);
}

export async function saveArticleNote(articleId: string, note: string): Promise<ArticleNote> {
  return apiJson<ArticleNote>(`/api/stories/${encodeURIComponent(articleId)}/note`, {
    method: 'PUT',
    json: { note },
  });
}

export async function deleteArticleNote(articleId: string): Promise<void> {
  await apiText(`/api/stories/${encodeURIComponent(articleId)}/note`, { method: 'DELETE' });
}
